import MarketingPage from "../components/MarketingPage";
import { APP_STORE_URL, ORG_SCHEMA, SOFTWARE_APP_SCHEMA, breadcrumbSchema } from "../lib/seo";

export default function HowItWorks() {
  return (
    <MarketingPage
      seo={{
        title: "How C-STYL Works | AI Stylist, Closet & Virtual Try-On",
        description: "Create your digital closet, get styled with weather-aware outfits, try looks on yourself with AI, shop and try new pieces, and plan what you'll wear — here's how C-STYL works.",
        path: "/how-it-works",
        testid: "how-it-works-page",
        jsonLd: [ORG_SCHEMA, SOFTWARE_APP_SCHEMA, breadcrumbSchema([{ name: "Home", path: "/" }, { name: "How It Works", path: "/how-it-works" }])],
      }}
      crumb="How It Works"
      eyebrow="Create · Style · Try · Shop · Plan"
      h1="How C-STYL Works"
      lead="From a guest closet in one tap to seeing an outfit on yourself — here's the full flow."
      sections={[
        { h2: "1. Create your closet", p: ["Add the clothes you already own by photo, multi-upload, wardrobe scan, receipt import or Spotted a Look. Everything is auto-tagged and reviewed by you before saving."] },
        { h2: "2. Get styled", p: ["C-STYL reads your local weather and builds a complete outfit from your closet for the occasion you choose, with a short explanation."] },
        { h2: "3. Try it on", p: ["Add a private reference photo and see any item or outfit visualized on your own body with AI virtual try-on."] },
        { h2: "4. Shop & try", p: ["Bring in pieces you find online and preview them on yourself before buying or adding them to your closet."] },
        { h2: "5. Plan your looks", p: ["Save outfits, track what you've worn, and schedule looks for tomorrow, in 3 days, or the weekend."] },
        { h2: "Web and native app", p: ["Some features — camera and gallery workflows, Share-to-C-STYL, saving generated images to your device, and daily reminders — require the native mobile app and are not available in web preview or Expo Go."] },
      ]}
      cta={{ label: "Download C-STYL", href: APP_STORE_URL, external: true }}
    />
  );
}
